import { Div } from '@sendoutcards/quantum-design-ui'
import React from 'react'

type ProgressBarProps = {
  percentage: number
}

export const ProgressBar = (props: ProgressBarProps) => {
  const { percentage } = props

  return (
    <Div
      width="100%"
      height="10px"
      overflow="hidden"
      style={{ borderRadius: '10px' }}
      backgroundColor="#E0DEDE"
    >
      <Div
        width={`${percentage}%`}
        height="100%"
        style={{
          background: 'linear-gradient(74deg, #34E3DF 16.27%, #02AEEE 86.38%)',
          transition: 'width 0.3s ease',
          borderRadius: 'inherit',
        }}
      />
    </Div>
  )
}
